import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {ConfigureEventsStep} from "./ConfigureEventsStep";
import {withTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {isOk} from "../../../utils/apiResponse";


class EditEventsModalClass extends Component {

    // `onSaved` sólo con el guardado confirmado: el `APIClient` nunca rechaza, así que un 4xx o un
    // `NETWORK_ERROR` llegaban al `then` y la pantalla decía «Conversión actualizada» sobre un error
    // (y el Panel avisaba al drawer con un OK fabricado; review C-app-05). Ante un error el modal
    // queda abierto, con lo elegido, para reintentar. Mismo patrón que `ConfigureEventsModal`.
    handleSave(selectedActions) {
        const {t, clientAdAccount} = this.props;
        const url = `${API_URL}client/ad_account/${clientAdAccount.id}/selected_actions`;
        new APIClient(url).call('POST', {selected_actions: selectedActions}).then((response) => {
            if (!isOk(response)) {
                toast.error(t('events_config_modal.save_error', {
                    name: clientAdAccount.name || clientAdAccount.account_id || '',
                    interpolation: {escapeValue: false},
                }));
                return;
            }
            this.props.toggle();
            this.props.onSaved();
        });
    }

    render() {
        const {t, isOpen, toggle, clientAdAccount} = this.props;
        return (
            <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
                <ModalHeader toggle={toggle}>{t('edit_events_modal.title')}</ModalHeader>
                {isOpen && <ConfigureEventsStep
                    channel={clientAdAccount.channel}
                    adAccountDbId={clientAdAccount.ad_account_id}
                    agencyClientAdAccountId={clientAdAccount.id}
                    initialSelectedActions={clientAdAccount.selected_actions || []}
                    onSave={(actions) => this.handleSave(actions)}
                    onSkip={toggle}
                    cancelLabel={t('configure_events.cancel')}
                />}
            </Modal>
        );
    }
}

export const EditEventsModal = withTranslation()(EditEventsModalClass);
export default EditEventsModal;
